import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const ShipmentReportTableHead = ({
  coloumn,
  handleRequestSort,
  orderBy,
  order,
}) => {
  const sortOptionColName = [
    "Shipment Number",
    "Origin Port Name",
    "Destination Port Name",
    "Consignee Name",
    "Consignor Name",
    "Cost",
    "Container Numbers And Type",
    "ATD",
    "ATA",
    "ETD",
    "ETA",
  ];
  const SortIcon = ({ value }) => {
    if (sortOptionColName.includes(value)) {
      if (order == value && orderBy == "asc") {
        return (
          <span>
            <ArrowDownwardIcon />
          </span>
        );
      } else if (order == value && orderBy == "desc") {
        return (
          <span>
            <ArrowUpwardIcon />
          </span>
        );
      }
      return (
        <span>
          <ImportExportIcon />
        </span>
      );
    }
    return <></>;
  };
  return (
    <TableHead>
      <TableRow>
        {coloumn?.map((col, index) => {
          if (col?.value)
            return (
              <TableCell
                key={index}
                onClick={() => {
                  if (sortOptionColName.includes(col?.displayColumnName)) {
                    handleRequestSort(col?.displayColumnName);
                  }
                }}
              >
                {col?.displayColumnName}{" "}
                <SortIcon value={col?.displayColumnName} />
              </TableCell>
            );
        })}
      </TableRow>
    </TableHead>
  );
};

export default ShipmentReportTableHead;
